// extracted by mini-css-extract-plugin
export default {"boxy-shadow":"Box_boxy-shadow__up7I1"};